import * as React from "react"

import type { ErrorEntry } from "../error-catalog"
import { executeAction, type ActionContext } from "../action-executor"

interface Props {
  entry: ErrorEntry
  ctx: ActionContext
}

/**
 * Variante `dual-cta`: dos botones (primary + secondary). Caso típico:
 * "comunícate con un asesor" donde uno abre WhatsApp y el otro llama por teléfono.
 *
 * Si el entry no trae `secondaryCta`, esta variante cae al mismo layout que
 * primary-cta — protegemos el render sin asumir el segundo botón.
 */
export const DualCtaLayout: React.FC<Props> = ({ entry, ctx }) => (
  <div className="text-center px-6 py-10 sm:py-12">
    {entry.icon && <div className="mx-auto mb-4 flex justify-center">{entry.icon}</div>}
    <h2 className="text-primary-800 text-xl sm:text-2xl font-semibold mb-3">
      {entry.title}
    </h2>
    {entry.description && (
      <div className="text-sm leading-[1.3] text-normal mb-6">
        {entry.description}
      </div>
    )}
    <div className="flex flex-col items-center gap-3">
      <button
        type="button"
        className="w-[260px] py-2.5 bg-active hover:bg-active2 text-white text-base font-semibold rounded-3xl shadow-[0px_2px_10px_rgba(161,161,161,.25)]"
        onClick={() => executeAction(entry.primaryCta.action, ctx)}
      >
        {entry.primaryCta.label}
      </button>
      {entry.secondaryCta && (
        <button
          type="button"
          className="w-[260px] py-2.5 bg-white border border-active text-active text-base font-semibold rounded-3xl"
          onClick={() => executeAction(entry.secondaryCta!.action, ctx)}
        >
          {entry.secondaryCta.label}
        </button>
      )}
    </div>
  </div>
)
